/**
 * Foydalanuvchi darajasi — sidebar va profilda.
 */
import { useQuery } from "@tanstack/react-query";
import { Star } from "lucide-react";
import { gamificationApi } from "@services/gamificationApi";

interface Props {
  compact?: boolean;
}

export function LevelBadge({ compact }: Props) {
  const { data } = useQuery({
    queryKey: ["gamification-level"],
    queryFn: () => gamificationApi.getMyLevel().catch(() => null),
    staleTime: 1000 * 60 * 10,
    retry: false,
  });

  if (!data?.level) return null;

  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/10 border border-amber-500/20 text-[10px] font-bold text-amber-300">
        <Star size={10} className="fill-amber-400 text-amber-400" />
        {data.level}
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-amber-500/8 border border-amber-500/15">
      <Star size={14} className="text-amber-400 fill-amber-400 shrink-0" />
      <div className="min-w-0">
        <p className="text-xs font-bold text-amber-200">Daraja {data.level}</p>
        <p className="text-[10px] text-slate-500 truncate">{data.xp} / {data.xp_for_next_level} XP</p>
      </div>
    </div>
  );
}
